import React, { Suspense } from 'react';
import Services from 'store/Services';
import { AppContextProvider } from 'app/AppContext';

const SupportVisualisation = React.lazy(
    () => import('widgets/supportVisualisation/SupportVisualisation')
);

export function SupportVisualisationPopup(props: { services: Services }) {
    const { services } = props;

    return (
        <AppContextProvider services={services}>
            <Suspense fallback={<div>Loading...</div>}>
                <SupportVisualisation />
            </Suspense>
        </AppContextProvider>
    );
}
